export default __webpack_public_path__ + "static/media/banner-bg.5241de9f.png";